// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var QueryParams = require("../../reason/QueryParams.bs.js");

var param = QueryParams.ParamConfigs.withDefault(QueryParams.ParamConfigs.booleanParam, false);

var IsNew = QueryParams.UseQueryParam.Make(param);

function use() {
  return IsNew.use("is_new");
}

exports.param = param;
exports.IsNew = IsNew;
exports.use = use;
/* param Not a pure module */
